module.exports = __webpack_public_path__ + "img/etuie.10f8e34a.jpg";